import { Theme } from '@mui/material/styles';

export const myTokensMobileStyles = (theme: Theme) => ({
  container: {
    pt: 0,
    pl: 3,
    pr: 1.5,
    pb: 0.5,
    [theme.breakpoints.up('sm')]: {
      px: 5
    }
  },
  tokenImage: {
    width: 20,
    height: 20,
    borderRadius: '50%',
    objectFit: 'cover',
    maxWidth: 'none'
  },
  amount: { fontVariationSettings: "'wght' 600", pl: 0.75, pr: 0.5 },
  unit: { fontVariationSettings: "'wght' 400" },
  ball: { borderRadius: '25px' },
  dataContainer: { width: 'auto' },
  dataItem: { width: 'auto' },
  title: { display: 'flex', flexWrap: 'nowrap' }
});
